import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Chọn bệnh nhân", -1)
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Mật khẩu(tối thiểu 6 ký tự)", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Đăng ký tài khoản bệnh nhân" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_Dropdown, {
            id: "team",
            modelValue: $setup.benhnhan_id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.benhnhan_id) = $event)),
            options: $setup.list,
            optionLabel: "thongTin",
            optionValue: "benhNhan_Id",
            placeholder: "Vui lòng nhập mã số hoặc tên bệnh nhân ..."
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_Password, {
            id: "password",
            modelValue: $setup.register.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.register.password) = $event)),
            toggleMask: "",
            feedback: true
          }, null, 8, ["modelValue"])
        ])
      ]),
      ($setup.valid)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: "Đăng ký",
            icon: "pi pi-plus-circle",
            iconPos: "left",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doRegister()))
          }))
        : (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            label: "Đăng ký",
            icon: "pi pi-plus-circle",
            iconPos: "left",
            disabled: "disabled"
          }))
    ]),
    _: 1
  }))
}